import { type_POPUP_LOADING, type_POPUP_ONBOARD } from '../types'

export function action_setOnboard(payload: boolean) {
    return {
        type: type_POPUP_ONBOARD,
        payload,
    }
}

export function action_setLoading(payload: boolean) {
    return {
        type: type_POPUP_LOADING,
        payload,
    }
}
